import React from 'react';
export const AddSupplier = React.lazy(() => import('./AddSupplier'));